@if (isPublishDate || isCloseDate) {
  <rt-button
    [rtTooltip]="
      isCloseDate
        ? isPublishDate
          ? translations.editPublishDates
          : translations.editCloseDate
        : translations.editPublishDate
    "
    [rtTooltipEnabled]="active"
    [disabled]="!active"
    variant="outline"
  >
    <rt-icon colorToken="colorIconPrimaryDefault" name="alarm" />
    @if (isPublishDate && !isCloseDate) {
      <span>
        <ng-container *ngTemplateOutlet="onlyPublishDateTpl" />
      </span>
    }
    @if (isCloseDate && !isPublishDate) {
      <span>
        <ng-container *ngTemplateOutlet="onlyCloseDateTpl" />
      </span>
    }
    @if (bothDates) {
      <span>
        <ng-container *ngTemplateOutlet="bothDatesTpl" />
      </span>
    }
  </rt-button>
} @else {
  <rt-icon-button
    [rtTooltip]="featureAvailable && translations.schedulePublishDates"
    [rtTooltipTemplate]="!featureAvailable ? featureGuardTpl : null"
    [rtTooltipEnabled]="active"
    [disabled]="!active"
    iconName="calendar-plus"
    shape="square"
    variant="outline"
  />
}

<ng-template #onlyPublishDateTpl>
  <span text-default>{{ translations.publishScheduled }}&nbsp;</span>
  <span>{{ getFormattedDay(schedulerData?.publishDate) }}</span>
</ng-template>
<ng-template #onlyCloseDateTpl>
  <span text-default>{{ translations.closeScheduled }}&nbsp;</span>
  <span>{{ getFormattedDay(schedulerData?.closeDate) }}</span>
</ng-template>
<ng-template #bothDatesTpl>
  <span text-default>{{ translations.jobScheduled }}&nbsp;</span>
  <span>
    {{ getFormattedDay(schedulerData?.publishDate) }} -
    {{ getFormattedDay(schedulerData?.closeDate) }}
  </span>
</ng-template>

<ng-template #featureGuardTpl>
  <rt-group layout-align-items-center>
    @if (discriminationIconColor) {
      <rt-icon
        name="upgrade"
        size="small-x"
        [colorToken]="discriminationIconColor"
        padding-right-small-x
      />
    }
    {{ discriminationTooltip }}
  </rt-group>
</ng-template>
